/** Created by azhou on 2019/3/19.*/
<template>
  <div>
    <public-title>餐饮管理
      <el-button slot="right" class="ml-auto" size="small" type="success" @click="addEatery">添加用餐</el-button>
      <div slot="right" class="text-right text-link ml-4" v-if="isGroup" @click="$router.back()">返回列表</div>
    </public-title>
    <div class="load-area">
      <el-tabs class="mb-4" v-model="activeName" @tab-click="status= activeName == 'all' ? '' : activeName;getStoreEateryLists({data:{status}})">
        <el-tab-pane :name="item.id" v-for="item in mealArr" :key="item.id" :label="item.name" />
      </el-tabs>
      <p v-if="StoreEateryList.total<=0">当前没有数据</p>
      <div v-else>
        <ul class="list-head"><li class="w-50" v-for="item in titleArr" :key="item">{{item}}</li></ul>
        <ul class="list-item" v-for="item in StoreEateryList.lists" :key="item.id">
          <li class="w-50 list-item-col">{{item.name}}</li>
          <li class="w-50 list-item-col">{{item.tag_name}}</li>
          <li class="w-50 list-item-col">{{item.price}}/{{item.price_type | formatVar('EateryType')}}</li>
          <li class="w-50 list-item-col">{{item.time | formatTimestamp(1)}}</li>
          <li class="w-50 list-item-col">
            <label :class="item.status == 0 ? 'text-danger' : 'text-success'">
              {{item.status == 1 ? '启用中' : '已下架'}}
              <span class="text-blue cursor-pointer" @click="changeStatus(item)">（{{item.status == 1 ? '下架' : '上架'}}）</span>
            </label>
          </li>
          <li class="w-50 list-item-col-end">
            <span class="text-link mr-2" @click="editEatery(item)">编辑</span>
            <span class="text-link" @click="deleteEatery(item)">删除</span>
          </li>
        </ul>
        <el-pagination background layout="prev, pager, next" class="mt-4"
                       :total="StoreEateryList.total" :current-page="Number(queryCon.page)"
                       @current-change="v => this.currentPage=v"/>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions,mapState,mapMutations } from 'vuex'

  export default {
    name: 'EateryLists',
    computed: {
      ...mapState(['StoreEateryList']),
      ...mapGetters(['storeInfo','isGroup']),
      queryCon() { return this.$route.query }
    },
    watch:{
      queryCon() { this.getStoreEateryLists({data:{...this.queryCon,page:this.currentPage,status}}); },
      currentPage() { this.$router.push({name:this.$route.name,query:{...this.queryCon,page:this.currentPage}}) }
    },
    data() {
      return {
        currentPage:1,
        titleArr: ['名称','用餐类型','价格/用餐种类','添加时间','状态','操作'],
        status: '',
        activeName:'all',
        mealArr: [{id:'all',name:'全部'},{id:'1',name:'已上架'},{id:'0',name:'已下架'}],
      }
    },
    mounted() {
      this.UPDATECURRENTSTORE({storeId:this.queryCon.store})
      this.getStoreEateryLists({data:{page:this.currentPage,status}});
    },
    beforeDestroy() {
      this.UPDATECURRENTSTORE({storeId:''})
    },
    methods:{
      ...mapMutations(['UPDATECURRENTSTORE']),
      ...mapActions(['getStoreEateryLists','deleteStoreEatery','setStoreEatery','addEditEatery']),
      //添加用餐
      addEatery() {
        if (!this.$GFUN.powerIsInArray([601])) { this._alert('您没有相关权限！',null,'error'); return; }
        this.$router.push({name:'addEditEatery',query:{store:this.queryCon.id}})
      },
      //删除用餐
      deleteEatery(item) {
        if (!this.$GFUN.powerIsInArray([603])) { this._alert('您没有相关权限！',null,'error'); return; }
        this._confirm('确认删除么？',() => { this.deleteStoreEatery(item.id) });
      },
      //编辑用餐
      editEatery(item) {
        if (!this.$GFUN.powerIsInArray([602])) { this._alert('您没有相关权限！',null,'error'); return; }
        this.$router.push({name:'addEditEatery',query:{store:this.queryCon.id,id:item.id}})
      },
      //上下架餐饮
      changeStatus(item) {
        this._confirm(`确定将餐饮${item.status ? '下架' : '上架'}么？`,() => {
          this.addEditEatery({
              type: 'edit',
              data: {
                ...item,
                restaurant_id: item.id,
                status: item.status == 1 ? '0' : '1'
              },
              successFun: res => {
                this.getStoreEateryLists({data:{page:this.currentPage,status}});
                this.activeName = 'all'
              }
          })
        })
      }
    },
  }
</script>
